import { get } from 'lodash';
import { connect } from 'react-redux';
import { setMessage } from '../Confirm/actions';
import {
  deselectAll,
  init,
  onFilterChange,
  onPageSizeChange,
  onSortChange,
  setActiveRow,
  setAllSelected,
  setCurrentPageSelected,
  setListExporting,
  toggleSelectAll,
} from './actions';
import SSPList from './component';

const mapStateToProps = (state) => ({
  lists: state.ssplists,
  c_uuid: (state.chargerDetails && state.chargerDetails.currentCharger && state.chargerDetails.currentCharger.c_uuid) || null,
});

const mapDispatchToProps = (dispatch) => ({
  init: (id, defaultPageSize, sorting) => dispatch(init(id, defaultPageSize, sorting)),
  onPageSizeChange: (id, opts) => dispatch(onPageSizeChange(id, opts)),
  onFilterChange: (id, opts) => dispatch(onFilterChange(id, opts)),
  onSortChange: (id, opts) => dispatch(onSortChange(id, opts)),
  selectRow: (ssplistId, id) => dispatch(setActiveRow(ssplistId, id)),
  deselectAllRows: (ssplistId) => dispatch(deselectAll(ssplistId)),
  setAllSelected: (ssplistId) => dispatch(setAllSelected(ssplistId)),
  toggleSelectAll: (ssplistId) => dispatch(toggleSelectAll(ssplistId)),
  setCurrentPageSelected: (ssplistId) => dispatch(setCurrentPageSelected(ssplistId)),
  setExporting: (ssplistId, isExporting) => dispatch(setListExporting(ssplistId, isExporting)),
  confirm: (message, ok) => dispatch(setMessage({ message, ok })),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  {
    ...ownProps,
    data: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id] : [],
    selectedDataIds: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id].selectedDataIds : [],
    selectAll: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id].selectAll : false,
    totalCount: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id].totalCount : false,
    isFetching: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id].isFetching : false,
    isExporting: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id].isExporting : false,
    forceUpdate: stateProps.lists[ownProps.id] ? stateProps.lists[ownProps.id].forceUpdate : false,
    init: (opts) => dispatchProps.init(ownProps.id, opts.page_size, ownProps.defaultSorted),
    onPageSizeChange: (opts) => dispatchProps.onPageSizeChange(ownProps.id, opts),
    onFilterChange: (opts) => dispatchProps.onFilterChange(ownProps.id, opts),
    onSortChange: (opts) => dispatchProps.onSortChange(ownProps.id, opts),
    selectRow: (id) => dispatchProps.selectRow(ownProps.id, id),
    deselectAllRows: () => dispatchProps.deselectAllRows(ownProps.id),
    setAllSelected: () => dispatchProps.setAllSelected(ownProps.id),
    toggleSelectAll: () => dispatchProps.toggleSelectAll(ownProps.id),
    setCurrentPageSelected: () => dispatchProps.setCurrentPageSelected(ownProps.id),
    confirm: dispatchProps.confirm,
    exportTable: () => {
      const exportProps = {
        ssplistId: ownProps.id,
        selectAll: stateProps.lists[ownProps.id].selectAll,
        items: stateProps.lists[ownProps.id].selectedDataIds,
        filter: stateProps.lists[ownProps.id].filter,
        sorting: stateProps.lists[ownProps.id].sorting,
        c_uuid: stateProps.c_uuid,
        customFilter: ownProps.customFilter,
        filterQuery: stateProps.lists[ownProps.id].appliedQuery,
      };

      if (ownProps.onExport) {
        dispatchProps.setExporting(ownProps.id, true);
        const result = ownProps.onExport(exportProps);

        if (result) {
          result.finally(
            () => {
              dispatchProps.setExporting(ownProps.id, false);
            },
          );
        } else {
          dispatchProps.setExporting(ownProps.id, false);
        }
      } else {
        throw Error('Function "onExport" should be implemented');
      }
    },
    error: get(stateProps.lists, `${ownProps.id}.error.response.data.message`, null)
        || get(stateProps.lists, `${ownProps.id}.error.response.data.errorMessage`, null),
  }
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SSPList);
